import City from '../../pages/city'

const CityRoute = [
  {
    path: '/city',
    name: 'city',
    component: City
  }
]

export default CityRoute



// WEBPACK FOOTER //
// ./src/router/city/index.js